import Mail from '../../../api/Mail';
import * as types from './mutation-types';

export const show = async ({commit}, {id}) => {
    const json = await new Mail().show(id);

    commit(types.TEMPLATE, json);
};

export const update = async (context, {id, params}) => {
    await new Mail().update(id, params)
};

export default {
    show,
    update,
};



// WEBPACK FOOTER //
// ./src/store/modules/mail/actions.js